import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './delete-habit-loading.style';

export const DeleteHabitLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
